// extracted by mini-css-extract-plugin
export default {"tooltip":"hoverText_tooltip__hFkjD","tooltipText":"hoverText_tooltipText__Ri4Kf"};